export function not(a, b) {
  var filtered = a.filter((artist) => {
    var found = b.find((x) => x.artistId === artist.artistId);
    return !found;
  });
  return filtered;
}

export function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

export function lightOrDark(color) {
  let r, g, b, hsp;
  // Check the format of the color, HEX or RGB?
  if (color.match(/^rgb/)) {
    // If HEX --> store the red, green, blue values in separate variables
    color = color.match(
      /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
    );

    r = color[1];
    g = color[2];
    b = color[3];
  } else {
    // If RGB --> Convert it to HEX: http://gist.github.com/983661
    color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));

    r = color >> 16;
    g = (color >> 8) & 255;
    b = color & 255;
  }

  // HSP equation from http://alienryderflex.com/hsp.html
  hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
  // Using the HSP value, determine whether the color is light or dark (127.5)
  const thrshold = 180;
  if (hsp > thrshold) {
    return 'light';
  } else {
    return 'dark';
  }
}

export const roundToCurrency = (value) => {
  return Math.round(value * 100) / 100;
};
export const roundToCurrencyAsString = (value) => {
  return String(Math.round(value * 100) / 100);
};
